import {LimitPeriod} from 'src/openapi/admin/models/LimitPeriod';
import {LimitType} from 'src/openapi/admin/models/LimitType';

export const LIMIT_PERIOD_TO_CAPTION: Record<LimitPeriod, string> = {
    [LimitPeriod.MINUTE]: 'Minute',
    [LimitPeriod.HOUR]: 'Hour',
    [LimitPeriod.DAY]: 'Day',
    [LimitPeriod.MONTH]: 'Month',
};

export const LIMIT_TYPE_TO_CAPTION: Record<LimitType, string> = {
    [LimitType.CREDITS]: 'Credits',
    [LimitType.SEARCH_AND_UPDATE]: 'Search & Update',
    [LimitType.SEARCH]: 'Search',
    [LimitType.UPDATE]: 'Update',
    [LimitType.PROFILES]: 'Profiles',
    [LimitType.OVERAGE]: 'Overage',
};

/**
 * Helpers for use in components where the value might be missing/undefined.
 * Always returns a string.
 */
export const getLimitPeriodCaption = (period?: LimitPeriod | null): string =>
    (period != null ? LIMIT_PERIOD_TO_CAPTION[period] : undefined) ?? '—';

export const getLimitTypeCaption = (type?: LimitType | null): string =>
    (type != null ? LIMIT_TYPE_TO_CAPTION[type] : undefined) ?? '—';
